import { forwardRef, useState } from 'react';
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTranslate } from 'react-admin';

type PasswordFieldProps = Omit<TextFieldProps, 'type' | 'InputProps'> & {
  showLabelKey?: string;
  hideLabelKey?: string;
};

export const PasswordField = forwardRef<HTMLDivElement, PasswordFieldProps>(
  ({ showLabelKey, hideLabelKey, ...props }, ref) => {
    const translate = useTranslate();
    const [visible, setVisible] = useState(false);

    const toggleLabel = translate(
      visible
        ? hideLabelKey ?? 'user-profile.password.hide'
        : showLabelKey ?? 'user-profile.password.show'
    );

    return (
      <TextField
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setVisible((v) => !v)}
                edge="end"
                size="small"
                aria-label={toggleLabel}
              >
                {visible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    );
  }
);

PasswordField.displayName = 'PasswordField';

export default PasswordField;
